/// <reference path="../../_ext/Editors/ItemEditorDialog.ts" />
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class MaterialRequestItemsDialog extends _Ext.ItemEditorDialog<MaterialRequestItemsRow> {
        protected getFormKey() { return MaterialRequestItemsForm.formKey; }
        //protected getIdProperty() { return MaterialRequestItemsRow.idProperty; }
        protected getLocalTextPrefix() { return MaterialRequestItemsRow.localTextPrefix; }
        // protected getNameProperty() { return MaterialRequestItemsRow.nameProperty; }
        //protected getService() { return MaterialRequestItemsService.baseUrl; }
        protected useViewMode(){return true;}
        public form = new MaterialRequestItemsForm(this.idPrefix);
         

        constructor() {
            super();

            //Make grid full width
            q.hideEditorLabel(this.form.BOMDetails);
            q.hideEditorLabel(this.form.ImageName);
            //q.hideEditorLabel(this.form.LaborDetails);
            q.setTextRightAlign(this.form.UnitRate);
            q.setTextRightAlign(this.form.UnitLabour);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.StonePieces);
            q.setTextRightAlign(this.form.StoneWeight);
            q.setTextRightAlign(this.form.DiamondPieces);
            q.setTextRightAlign(this.form.DiamondWeight);
            q.setTextRightAlign(this.form.OtherPieces);
            q.setTextRightAlign(this.form.OtherWeight);
            q.setTextRightAlign(this.form.Pieces);




            // **** Assign Values to BOM and Labor Editor ****
            // this will be used to calculate Rate for RM and Labor while adding new item.
            this.form.BOMDetails.RateListId = this.RateListId;
            //this.form.LaborDetails.LaborListId = this.LaborListId;
            //this.form.LaborDetails.LaborMarkup = this.LaborMarkup;


            // **** On Pieces Change Event **** 
            this.form.Pieces.changeSelect2(e => {
                var pieces = parseInt(this.form.Pieces.value.toString());
                var netamount = parseFloat(this.form.NetAmount.value.toString());
                this.form.GrossAmount.value = (pieces * netamount);
            });
            // **** On Pieces Change Event **** 
            this.form.Pieces.changeSelect2(e => {
                if (this.form.ItemTypeId.value != 101) {
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
                    if (parseInt(this.form.CalcOnId.value) == 3) {
                        this.form.NetAmount.value = pieces * parseFloat(this.form.UnitRate.value.toString());
                        this.form.GrossAmount.value = this.form.NetAmount.value;
                    }
                }
                else {
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, true);
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    var netamount = parseFloat(this.form.NetAmount.value.toString());
                    this.form.GrossAmount.value = (pieces * netamount);
                }
            });
            // **** On Pieces Change Event **** 
            this.form.Weight.changeSelect2(e => {
                if (this.form.ItemTypeId.value != 101) {
                    var weight = parseFloat(this.form.Weight.value.toString());
                    //Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
                    if (parseInt(this.form.CalcOnId.value) == 4 || parseInt(this.form.CalcOnId.value) == 5) {
                        this.form.NetAmount.value = weight * parseFloat(this.form.UnitRate.value.toString());
                        this.form.GrossAmount.value = this.form.NetAmount.value;
                    }
                }
                else {
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, true);
                }
            });
            this.form.UnitRate.changeSelect2(e => {
                if (parseInt(this.form.CalcOnId.value) == 3) {
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    this.form.NetAmount.value = pieces * parseFloat(this.form.UnitRate.value.toString());
                    this.form.GrossAmount.value = this.form.NetAmount.value;
                }
                else if (parseInt(this.form.CalcOnId.value) == 4 || parseInt(this.form.CalcOnId.value) == 5) {
                    var weight = parseFloat(this.form.Weight.value.toString());
                    this.form.NetAmount.value = weight * parseFloat(this.form.UnitRate.value.toString());
                    this.form.GrossAmount.value = this.form.NetAmount.value;
                }
            });
            this.form.CalcOnId.changeSelect2(e => {
                if (this.form.ItemTypeId.value != 101) {
                    var weight = parseFloat(this.form.Pieces.value.toString());
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
                    if (parseInt(this.form.CalcOnId.value) == 4 || parseInt(this.form.CalcOnId.value) == 5) {
                        this.form.NetAmount.value = weight * parseFloat(this.form.UnitRate.value.toString());
                    } else {
                        var pieces = parseInt(this.form.Pieces.value.toString());
                        if (parseInt(this.form.CalcOnId.value) == 3) {
                            this.form.NetAmount.value = pieces * parseFloat(this.form.UnitRate.value.toString());
                        }
                    }
                }
                else {
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, true);
                }
            });

            // **** On Wastage % Change Event **** 
            this.form.WstPer.changeSelect2(e => {
                this.form.WstWt.value = this.form.NetWeight.value * ((this.form.WstPer.value) / 100);

            });
            this.form.HasBom.changeSelect2(e => {
                if (this.form.HasBom.value) {
                    q.hideField(this.form.KaratId)
                    q.hideField(this.form.Purity)
                }
                else {
                    q.showAndSetRequiredField(this.form.KaratId)
                    q.showAndSetRequiredField(this.form.Purity)
                    q.showAndSetRequiredField(this.form.MetalId)
                }

            })
            var min = 0, max = 0, std = 0;
            this.form.KaratId.changeSelect2(e => {
                var KaratId = Q.toId(this.form.KaratId.value);
                var purity: OMS.AttributeMasterRow;
                OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                    purity = response.Entity
                }, { async: false });
                min = purity.MinPurity;
                max = purity.MaxPurity;
                std = purity.StdPurity;
                this.form.Purity.value = std;
            });
            this.form.Purity.change(e => {
                var current = this.form.Purity.value;
                if (current < min || current > max) {
                    Q.alert("Enter Purity between  " + min.toString() + "  to  " + max.toString());
                    this.form.Purity.value = std;
                }
            });

            (this.form.BOMDetails.view as any).onRowCountChanged.subscribe(() => {

                    var Pcs = 0, Wt = 0, othrpcs = 0, othrwt = 0, clrpcs = 0, clrwt = 0, diapcs = 0, diawt = 0, grswt = 0, cts = 0, gms = 0, rate = 0;
                    for (var k of this.form.BOMDetails.getItems()) {

                        if (k.ItemTypeId == 104) {
                            Wt += k.Weight;
                        }
                        if (k.ItemTypeId == 105 && k.CalcOnId == 5) {
                            cts += k.Weight;
                            diapcs += k.Pieces
                        }
                        if (k.ItemTypeId == 105 && k.CalcOnId == 4) {
                            gms += k.Weight;
                            clrpcs += k.Pieces;
                        }

                        rate += k.BomAmount;

                    }
                    this.form.NetWeight.value = Wt;
                    this.form.OtherPieces.value = othrpcs;
                    this.form.StonePieces.value = clrpcs;
                    this.form.StoneWeight.value = gms;
                    this.form.DiamondPieces.value = diapcs;
                    this.form.DiamondWeight.value = cts;
                    this.form.Weight.value = Wt + gms + (cts / 5);
                    this.form.UnitRate.value = rate;
                    this.form.NetAmount.value = this.form.UnitRate.value + this.form.UnitLabour.value;

                    if (this.form.Pieces.value != null) {
                        var pieces = parseInt(this.form.Pieces.value.toString());
                        var netamount = parseFloat(this.form.NetAmount.value.toString());
                        this.form.GrossAmount.value = (pieces * netamount);
                    }
                    if (!this.HasBom && this.entity.ItemTypeId == 101) {
                        this.form.Weight.value = this.entity.Weight == 0 ? 1 : this.entity.Weight;
                        this.form.NetWeight.value = this.entity.NetWeight;
                        this.form.UnitRate.value = this.entity.UnitRate;
                        this.form.NetAmount.value = this.entity.UnitRate * this.entity.Weight;
                        this.form.GrossAmount.value = this.entity.UnitRate * this.entity.Weight;
                    }
                });

             


            // **** On Labor Rate Change Event **** 
            this.form.UnitLabour.changeSelect2(e => {
                this.form.NetAmount.value = parseFloat(this.form.UnitRate.value.toString()) + parseFloat(this.form.UnitLabour.value.toString());
                if (this.form.Pieces.value != null) {
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    var netamount = parseFloat(this.form.NetAmount.value.toString());
                    this.form.GrossAmount.value = (pieces * netamount);
                }
            });

            // **** On Product Code Change Event **** 
            //Validate Product Code for Duplication 
            this.form.ProductCode.changeSelect2(e => {
                if (this.form.ProductCode.value != null) {
                    try {

                        let PrdId = 0;
                        var equalFilter = { "ProductCode": this.form.ProductCode.value.toUpperCase() };

                        OMS.ProductMasterService.List({ EqualityFilter: equalFilter, Take: 1 },
                            response => {
                                if (response.Entities.length > 0)
                                    PrdId = response.Entities[0].ProductId;
                            }, {
                            async: false
                        }
                        );

                        if (PrdId > 0) {
                            Q.notifyError("Duplicate Product Code " + this.form.ProductCode.value);
                            this.form.ProductCode.value = "";
                            this.form.ProductCode.element.focus();
                            return;
                        }
                        else {
                            this.form.ProductCode.value = this.form.ProductCode.value.toUpperCase();
                        }

                    }
                    catch (undefined) {

                    }
                }
            });

        }

        protected onDialogOpen() {
            super.onDialogOpen();
            this.Setfields();
        }

        private Setfields() {

            if (this.form.ProductTypeId.value == "5" || this.form.ProductTypeId.value == "6" || this.form.ProductTypeId.value == "7") {
                this.form.KaratId.getGridField().toggle(true);
                this.form.MetalColorId.getGridField().toggle(true);
                this.form.Purity.getGridField().toggle(true);

                this.form.SubCategoryId.getGridField().toggle(false);
                this.form.ShapeId.getGridField().toggle(false);
                this.form.QualityId.getGridField().toggle(false);
                this.form.StoneColorId.getGridField().toggle(false);
                this.form.StoneSizeId.getGridField().toggle(false);

                // Set Required True
                Serenity.EditorUtils.setRequired(this.form.KaratId, true);
                Serenity.EditorUtils.setRequired(this.form.MetalColorId, true);
                Serenity.EditorUtils.setRequired(this.form.Purity, true);

                // Set Required false
                Serenity.EditorUtils.setRequired(this.form.SubCategoryId, false);
                Serenity.EditorUtils.setRequired(this.form.ShapeId, false);
                Serenity.EditorUtils.setRequired(this.form.QualityId, false);
                Serenity.EditorUtils.setRequired(this.form.StoneColorId, false);
                Serenity.EditorUtils.setRequired(this.form.StoneSizeId, false);


                if (this.form.ItemTypeId.value == 0)
                    this.form.ItemTypeId.value = 104;

                if (this.form.CategoryId.value.length == 0)
                    this.form.CategoryId.value = "123";

                if (this.form.ProductTypeId.value == "5")
                    this.form.SubCategoryId.value = "301";

                if (this.form.ProductTypeId.value == "6")
                    this.form.SubCategoryId.value = "302";

                if (this.form.ProductTypeId.value == "7")
                    this.form.SubCategoryId.value = "303";
            }

            if (this.form.ProductTypeId.value == "11" || this.form.ProductTypeId.value == "12" || this.form.ProductTypeId.value == "13") {
                this.form.SubCategoryId.getGridField().toggle(true);
                this.form.ShapeId.getGridField().toggle(true);
                this.form.QualityId.getGridField().toggle(true);
                this.form.StoneColorId.getGridField().toggle(true);
                this.form.StoneSizeId.getGridField().toggle(true);

                this.form.KaratId.getGridField().toggle(false);
                this.form.MetalColorId.getGridField().toggle(false);
                this.form.Purity.getGridField().toggle(false);

                //this.form.SubCategoryId.value = "0";


                //Set Required True
                Serenity.EditorUtils.setRequired(this.form.SubCategoryId, true);
                Serenity.EditorUtils.setRequired(this.form.ShapeId, true);
                Serenity.EditorUtils.setRequired(this.form.QualityId, true);
                Serenity.EditorUtils.setRequired(this.form.StoneColorId, true);
                Serenity.EditorUtils.setRequired(this.form.StoneSizeId, true);


                //Set Required false
                Serenity.EditorUtils.setRequired(this.form.KaratId, false);
                Serenity.EditorUtils.setRequired(this.form.MetalColorId, false);
                Serenity.EditorUtils.setRequired(this.form.Purity, false);

                if (this.form.ItemTypeId.value == 0)
                    this.form.ItemTypeId.value = 105;

                if (this.form.CategoryId.value.length == 0)
                    this.form.CategoryId.value = "124";
                this.form.SieveId.value = "131";

            }

        }

         
         
    }
}